import { Check } from 'lucide-react';
import { useTranslate } from 'ra-core';
import { cn } from '../../lib/utils';

const BulkOperationDialogStepperSteps = [
  {
    id: 'get-template',
    index: 0,
    label: 'Prepare',
  },
  {
    id: 'upload',
    index: 1,
    label: 'Upload',
  },
  {
    id: 'grid',
    index: 2,
    label: 'Overview',
  },
  {
    id: 'process',
    index: 3,
    label: 'Summary',
  },
] as const;

export type BulkOperationDialogSteps =
  (typeof BulkOperationDialogStepperSteps)[number]['id'];

export interface BulkOperationDialogStepperProps {
  step: BulkOperationDialogSteps;
}

export const BulkOperationDialogStepper = ({
  step,
}: BulkOperationDialogStepperProps) => {
  const translate = useTranslate();
  const stepIndex =
    BulkOperationDialogStepperSteps.find((s) => s.id === step)?.index ?? 0;

  return (
    <ol className="hidden w-40 shrink-0 space-y-5 border-r bg-muted/20 p-6 sm:block">
      {BulkOperationDialogStepperSteps.map((value, index) => {
        const isCurrent = index === stepIndex;
        const isComplete = index < stepIndex;

        return (
          <li
            key={value.id}
            className="flex items-center gap-3 text-sm"
            aria-current={isCurrent ? 'step' : undefined}
          >
            <span
              className={cn(
                'flex size-7 shrink-0 items-center justify-center rounded-full border text-xs font-medium',
                isCurrent &&
                  'border-primary bg-primary text-primary-foreground',
                isComplete && 'border-primary text-primary',
                !isCurrent && !isComplete && 'text-muted-foreground'
              )}
            >
              {isComplete ? <Check className="size-4" /> : index + 1}
            </span>
            <span
              className={cn(
                isCurrent
                  ? 'font-medium text-foreground'
                  : 'text-muted-foreground'
              )}
            >
              {translate(`moonstar.bulk_operation.steps.${value.id}`, {
                _: value.label,
              })}
            </span>
          </li>
        );
      })}
    </ol>
  );
};
